export default "__VITE_ASSET__K7kk7hEF__"